import { Button } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { userRole } from "@/constant";
import DashboardBody from "./redesign/DashboardBody";
import { popFromHistory } from "@/redux/slices/dashboardV2.slice";
import { setActiveDashboard } from "@/redux/slices/user.slice";

const DashboardListView = () => {
  const { id } = useParams();
  const { userDetails } = useSelector((state) => state.user);
  const { prevDashboardHistory } = useSelector((state) => state.dashboardV2) || {};
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // state
  const [layouts, setLayouts] = useState({});
  const [gridData, setGridData] = useState([]);

  return (
    <div className="mt-3 h-100">
      <div className="border p-3 h-100 d-flex flex-column">
        <DashboardBody {...{ mode: "view", id, layouts, setLayouts, gridData, setGridData }} />
        <div className="d-flex align-items-center justify-content-end gap-1 mt-3">
          {![userRole.public, userRole.user].includes(userDetails?.role) && (
            <Link to={`/edit-dashboard/${id}`} className="d-none d-md-inline">
              <Button type="primary">Edit</Button>
            </Link>
          )}
          {prevDashboardHistory && prevDashboardHistory.length > 0 ? (
            <Button
              onClick={() => {
                const prev = prevDashboardHistory[prevDashboardHistory.length - 1];
                dispatch(popFromHistory());
                if (typeof prev === "object" && prev !== null) {
                  if (prev.activeDashboardId) {
                    dispatch(setActiveDashboard(prev.activeDashboardId));
                  }
                  navigate(prev.url || "/");
                } else if (typeof prev === "string") {
                  navigate(prev);
                }
              }}
              className="text-white bg-secondary"
            >
              Back
            </Button>
          ) : (
            <Button onClick={() => navigate(-1)} className="text-white bg-secondary">
              Back
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardListView;
